import React from 'react';
import Layout from '../components/Layout';
import Ramplist from '../components/virtualRamp/RampList';


/**
 * Página de listado de órdenes de compra
 * Utiliza el componente Layout para la estructura básica
 * y el componente ASNList para mostrar la lista de órdenes
 */
const RampsList = () => {
  return (
    <Layout>
      <div>
        <Ramplist />
      </div>
    </Layout>
  );
};

export default RampsList;